import { render, staticRenderFns } from "./open-banking-deposits.vue?vue&type=template&id=a076796e&scoped=true"
import script from "./open-banking-deposits.vue?vue&type=script&lang=js"
export * from "./open-banking-deposits.vue?vue&type=script&lang=js"
import style0 from "./open-banking-deposits.vue?vue&type=style&index=0&id=a076796e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a076796e",
  null
  
)

export default component.exports